module.exports = __webpack_public_path__ + "static/media/zucchini.1f52cf88.webp";